export default __webpack_public_path__ + "static/media/agreement.e25038a7.svg";